/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';
import PropTypes from 'prop-types';
import {Fade} from 'react-reveal';
import { Row, Col } from 'react-bootstrap';

import MicrositeSection from '../MicrositePage/MicrositeSection/MicrositeSection';
import BaseComponent from "../../../panther/components/base/BaseComponent";

import prague_heat from "../../../resources/img/prague_heat.gif";
import bucina_temperatures from "../../../resources/img/bucina_temperatures.gif";

import './style.css';

class Service3 extends BaseComponent {
    constructor(props) {
        super(props);
    }

    render() {
        let content = this.renderContent();

        return (
            <MicrositeSection
                id={this.props.id}
                name={this.props.name}
                textCentered={this.props.textCentered}
                content={content}
            />
        );
    }

    renderContent(){
        return (
            <div>
                <Row className="show-grid">
                    <Fade>
                        <Col xs={12} sm={10} smOffset={1} md={10} mdOffset={1} lg={8} lgOffset={2}>
                            <p className="centered">Satellite data bring an unique opportunity to monitor the spatial distribution of land surface temperatures in any area of your interest.</p>
                            <p className="centered">Comparing to standard measuring methods, you will not only get the information about the temperature measured at one place (a meteorological measurement station) but a comprehensive map showing geographical distribution of land surfaces temperatures. From this, the link between the structure of the land cover and land surface temperature is very obvious, so you can follow the impact of local land cover on local level of heat stress. For example, the effect of the urban heat island is easily observable. The maximum surface temperatures occur in the densiest urban fabric areas, especially in the centres of the cities. Also, in the agricultural land, it is obvious and also in the fields without vegetation cover, where large patches of bare soil are exposed to the solar radiance during all day.</p>
                        </Col>
                    </Fade>
                </Row>
                <Row className="show-grid centered">
                    <Col xs={12} xsOffset={0} sm={12} smOffset={0} md={12} mdOffset={0} lg={12} lgOffset={0}>
                        <div className="ptr-animated-gif-container">
                            <img className="ptr-animated-gif" src={prague_heat}/>
                            <span className="centered">Analysis: GISAT © 2018,  Satellite imagery: Landsat-8 © USGS (2018)</span>
                        </div>
                    </Col>
                </Row>
                <Row className="show-grid">
                    <Fade>
                        <Col xs={12} sm={10} smOffset={1} md={10} mdOffset={1} lg={8} lgOffset={2}>
                            <p className="centered">You will not only be able to explore the whole city and surrounding areas, but also go to quite high level of spatial detail – and check the local distribution and differences of land surface temperatures in your specific areas of interest, for example for specific quarters or even functional units inside the city.</p>
                        </Col>
                    </Fade>
                </Row>
                <Row className="show-grid centered">
                    <Col xs={12} xsOffset={0} sm={12} smOffset={0} md={12} mdOffset={0} lg={12} lgOffset={0}>
                        <div className="ptr-animated-gif-container">
                            <img style={{maxWidth: '50rem'}} className="ptr-animated-gif" src={bucina_temperatures}/>
                            <span className="centered">Land Surface Temperature for Blucina cadastre (South Moravia, CZ). Analysis: GISAT © 2018</span>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

Service3.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    textCentered: PropTypes.bool
};

export default Service3;